import React, { Component } from "react";

import "./CsListItem.css";
import { RecordVoiceOver, NoteAdd, Note, Save, Cancel, ChatBubble, Chat, WhatsApp } from "@mui/icons-material"
import { Chip, Divider, TextField, Tooltip, CircularProgress, Paper, Button, ButtonGroup, Grid } from "@mui/material";
import Global from "../../customlib/Global";
import Api from "../../customlib/Api";
import axios from "axios";
import moment from "moment";

class CsContactListItem extends Component {
    state = {
        isSavingNote: false,
        isEditingNote: false,
        isStarting: false,
        note: ""
    };

  getColor = () => {
    var randomColor = Math.floor(Math.random()*16777215).toString(16);
    return "#"+randomColor;
  }

  handleNote = (event) => {
    this.setState({ note: event.target.value });
  };

  handleSetHelpState = (conversation, helpState) => {
    if (helpState === "SOLVING") {
      this.setState({ isStarting: true });
    }

    let params = {
      userId: Global.get().user.id,
      contactId: conversation.contactId,
      helpState: helpState,
      archived: false,
      csId: Global.get().user.id,
      csName: Global.get().user.name
    };
    
    console.log("PARAMS_SET_CS_HELP", params);
    console.log("HEADER", Api.getRequestHeader());
    axios
      .post(Api.setCsHelp(), params, Api.getRequestHeader())
      .then((response) => {
        console.log("SETCSHELP : ", response.data);

        if(helpState === "SOLVING"){
            const afterStarted = (ticket) => {
                conversation.csHelpState = helpState;
                if (ticket) {
                    conversation.ticketStatus = ticket.status;
                    conversation.ticketNumber = ticket.ticket_number || conversation.ticketNumber;
                    conversation.queueLabel = ticket.queue_label || conversation.queueLabel;
                }

                if (typeof this.props.reloadCsHelpList === 'function') {
                    this.props.reloadCsHelpList();
                }

                if (typeof this.props.onCustomerStarted === 'function') {
                    this.props.onCustomerStarted(conversation);
                }

                if (typeof this.props.onOpenChat === 'function') {
                    this.props.onOpenChat(conversation);
                }
            };

            // CS Ticketing (PRD v1.3.0): kalau customer ini punya tiket aktif,
            // panggil endpoint take untuk pindahkan tiket ke `sedang_ditangani`
            // dan trigger HSM "Mohon ditunggu ticket anda sedang kami tangani...".
            if (conversation.ticketId) {
                axios
                    .post(Api.csTicketTake(conversation.ticketId), {}, Api.getRequestHeader())
                    .then((resp) => {
                        console.log("TICKET_TAKE ok:", resp.data);
                        afterStarted(resp.data?.data?.ticket);
                    })
                    .catch((err) => {
                        console.warn("TICKET_TAKE failed:", err?.message);
                        if (typeof this.props.showSnackBar === 'function') {
                            this.props.showSnackBar("Gagal mengubah status tiket menjadi sedang dilayani");
                        }
                    })
                    .finally(() => {
                        this.setState({ isStarting: false });
                    });
            } else {
                afterStarted();
                this.setState({ isStarting: false });
            }
        } else {
            if (typeof this.props.reloadCsHelpList === 'function') {
                this.props.reloadCsHelpList();
            }
            this.setState({ isStarting: false });
        }

      })
      .catch((error) => {
        this.setState({ errorMessage: error.message, isStarting: false });
        console.error("There was an error!", error);
      });
  }

  handleSaveNote = (conversation, note) => {

    this.setState({isSavingNote: true}, () => {
      let params = {
        userId: Global.get().user.id,
        userName: Global.get().user.name,
        contactId: conversation.contactId,
        note: note
      };
      
      axios
        .post(Api.csSaveNote(), params, Api.getRequestHeader())
        .then((response) => {
          console.log("SAVECSNOTE : ", response.data);
          
          this.setState({isSavingNote: false, isEditingNote: false}, ()=>{
              this.props.onUpdateNote(conversation, note);
          });
          
        })
        .catch((error) => {
          this.setState({ errorMessage: error.message });
          console.error("There was an error!", error);
        });
      });
  }

    handleToggleShowNoteInput = () => {
        let showState = this.state.isEditingNote;
        this.setState({isEditingNote: !showState});
    }

  componentDidMount() {
    this.setState({note: this.props.data.csNote});
    // shave(".conversation-snippet", 25);
  }

  render() {
    const { fromName, text, fromNumber, unreadCounter, assignToUserName, csHelpState, showButton, csNote, lastWaCsLog, contactLabel, firstContactAssignedToName, lastMessageTime, csCreatedAt, csId, csName, queueLabel, ticketNumber, ticketStatus} = this.props.data;

    return (
      <>
        <Paper elevation={0}
            className={this.getListItemClasses()}
            style={{cursor: "default"}}
            // onClick={() => {this.props.onSelect(this.props.data);}}
            >
            <div className="container-fluid" style={{padding: "5px 0 2px 0"}}>

                <Grid container alignItems="flex-start" spacing={1}>
                  <Grid item xs={queueLabel ? 8 : 12}>
                    <div className="conversation-title">
                      {fromName} &nbsp;
                      <span className={this.getUreadCounterClasses(unreadCounter)}>({unreadCounter})</span>
                    </div>
                  </Grid>
                  {queueLabel && (
                    <Grid item xs={4} style={{textAlign: "right"}}>
                      <Tooltip title={ticketNumber || "Nomor Ticket"}>
                        <span style={{
                          fontWeight: "bold",
                          fontSize: "14px",
                          color: ticketStatus === "sedang_ditangani" ? "#2e7d32" : "#c62828",
                          fontFamily: "monospace",
                        }}>
                          {queueLabel}
                        </span>
                      </Tooltip>
                    </Grid>
                  )}
                </Grid>
                {ticketNumber && (
                  <div style={{fontSize: "9px", color: "#666", marginBottom: "4px", fontFamily: "monospace"}}>
                    {ticketNumber}
                    {ticketStatus === "sedang_ditangani" && (
                      <span className="badge badge-success" style={{marginLeft: 6, fontSize: "8px"}}>SEDANG DITANGANI</span>
                    )}
                  </div>
                )}
                
                <div>
                    <span className="badge badge-secondary" style={{fontSize: "8px"}}>{Global.maskPhoneNumber(fromNumber)}</span>&nbsp;
                        {/* {
                            csHelpState !== undefined && csHelpState !== "OFF" ? 
                            (
                                <div className="badge badge-warning">
                                CS : {csHelpState === "SOLVED" ? "DONE" : csHelpState}
                                </div>
                            ) : 
                            (
                                <></>
                            )
                        } */}

                    <div className="badge text-info" style={{fontSize: "9px"}}><RecordVoiceOver style={{width: 15}} /> {assignToUserName !== null && assignToUserName !== undefined && assignToUserName.length > 0 ? assignToUserName : firstContactAssignedToName}</div>&nbsp;
                    {   
                    contactLabel !== undefined && contactLabel !== null && contactLabel.length > 0 ? 
                    (
                        <><span className={Global.getLabelClasses(contactLabel)} style={{fontSize: "8px"}}>{contactLabel}</span>&nbsp;</>
                    ) : 
                    (<></>)
                    }
                    <p className="conversation-snippet" style={{margin: "0 0 5px 0"}}>{text}</p>
                    <Grid container spacing={1}>
                        <Grid item xs={6} style={{fontSize: "9px", fontWeight: "bold"}}>
                            CS : {csName}
                            {/* <Chip label={`CS : ${csName}`} sx={{fontSize: "10px"}} size="small"/> */}
                        </Grid>
                        <Grid item xs={6} style={{fontSize: "9px", fontWeight: "bold", textAlign: "right"}}>Masuk CS : { moment(csCreatedAt).tz("asia/jakarta").format("DD-MM-YYYY HH:mm:ss")}</Grid>
                    </Grid>
                    <div>
                        <ButtonGroup fullWidth size="small" aria-label="Small button group">
                            {
                                showButton === true && csHelpState==="OPEN" ? 
                                (
                                    <Tooltip title="Klik untuk memulai sesi bantuan">
                                        <Button color="error" size="small" variant="contained" disabled={this.state.isStarting} onClick={() => {this.handleSetHelpState(this.props.data, "SOLVING")}}>
                                            {this.state.isStarting ? "Starting..." : "Start"}
                                        </Button>
                                    </Tooltip>
                                    // </div>
                                ) : 
                                (
                                    <></>
                                )
                            }

                            {
                                showButton === true && csHelpState==="SOLVING" ? 
                                (
                                    <Tooltip title={"Akhiri sesi bantuan untuk customer ini, customer akan hilang dari list ini"}>
                                    {/* <div className="btn btn-primary btn-block btn-sm" onClick={() => {this.handleSetHelpState(this.props.data, "SOLVED")}}> */}
                                    <Button color="warning" size="small" variant="contained" onClick={() => {this.handleSetHelpState(this.props.data, "OFF")}}>
                                        Finish
                                    </Button>
                                    </Tooltip>
                                ) : 
                                (<></>)
                            }

                            {
                                showButton === true && csHelpState==="SOLVED" ? 
                                
                                Global.get().admin === true || Global.isCustomerServiceSpv() || Global.isCustomerService() ? 
                                
                                (
                                    <Tooltip title={"Akhiri sesi bantuan untuk customer ini, customer akan hilang dari list ini"}>
                                        <Button color="warning" size="small" variant="contained" onClick={() => {this.handleSetHelpState(this.props.data, "OFF")}}>
                                            Finish
                                        </Button>
                                    </Tooltip>
                                ) : 
                                (
                                    <Tooltip title={"Akhiri sesi bantuan untuk customer ini, customer akan hilang dari list ini"}>
                                        <Button color="warning" size="small" variant="contained" disabled>
                                            Finish
                                        </Button>
                                    </Tooltip>
                                ) 
                                : 
                                (
                                    <></>
                                )
                            }
                            {/* <Button color="primary" key="two">Add Note</Button> */}
                            <Tooltip title={csHelpState === "OPEN" ? "Klik tombol MULAI untuk terlebih dahulu" : "Buka halaman chat"}>
                                <Button color="primary" variant="contained" key="two" disabled={csHelpState === "OPEN"}
                                    onClick={() => {this.props.onOpenChat(this.props.data);}}>
                                    <WhatsApp style={{width: 17}} /> &nbsp;
                                    Open Chat
                                </Button>
                            </Tooltip>
                        </ButtonGroup>
                    </div>

                    {/* <div className="row">
                        <div className="col-6 text-left">
                        {
                            showButton === true && csHelpState==="OPEN" ? 
                            (
                                <Tooltip title="Klik untuk memulai sesi bantuan">
                                    <Button color="primary" size="small" variant="contained" style={{padding: "0px", fontSize: "10px"}} onClick={() => {this.handleSetHelpState(this.props.data, "SOLVING")}}>
                                        Start
                                    </Button>
                                </Tooltip>
                                // </div>
                            ) : 
                            (
                                <></>
                            )
                        }

                        {
                            showButton === true && csHelpState==="SOLVING" ? 
                            (
                                <Tooltip title={"Akhiri sesi bantuan untuk customer ini, customer akan hilang dari list ini"}>
                                <div className="btn btn-primary btn-block btn-sm" onClick={() => {this.handleSetHelpState(this.props.data, "SOLVED")}}>
                                <Button color="warning" size="small" variant="contained" style={{padding: "0px", fontSize: "10px"}} onClick={() => {this.handleSetHelpState(this.props.data, "OFF")}}>
                                    Finish
                                </Button>
                                </Tooltip>
                            ) : 
                            (<></>)
                        } */}

                        {/* {
                            showButton === true && csHelpState==="SOLVED" ? 
                            
                            Global.get().admin === true || Global.isCustomerServiceSpv() || Global.isCustomerService() ? 
                            
                            (
                                <Tooltip title={"Akhiri sesi bantuan untuk customer ini, customer akan hilang dari list ini"}>
                                    <Button color="warning" size="small" variant="contained" style={{padding: "0px", fontSize: "10px"}} onClick={() => {this.handleSetHelpState(this.props.data, "OFF")}}>
                                        Finish
                                    </Button>
                                </Tooltip>
                            ) : 
                            (
                                <Tooltip title={"Akhiri sesi bantuan untuk customer ini, customer akan hilang dari list ini"}>
                                    <Button color="warning" size="small" variant="contained" style={{padding: "0px", fontSize: "10px"}} disabled>
                                        Finish
                                    </Button>
                                </Tooltip>
                            ) 
                            : 
                            (
                                <></>
                            )
                        } */}

                            {/* <Tooltip title={this.state.isEditingNote ? "Tutup input catatan" : "Input catatan"}>
                                <div className="btn btn-success btn-sm" onClick={this.handleToggleShowNoteInput}>
                                    {
                                        this.state.isEditingNote ? 
                                        (
                                            <Cancel />
                                        ) : 
                                        (
                                            <NoteAdd />
                                        )
                                    }
                                </div>
                            </Tooltip> */}

                        {/* </div> */}
                        {/* <div className="col-6 text-right">
                            <Tooltip title={this.state.isEditingNote ? "Tutup input catatan" : "Input catatan"}>
                                <span style={{padding: "0px", cursor: "pointer"}} onClick={this.handleToggleShowNoteInput}>
                                    {
                                        this.state.isEditingNote ? 
                                        (
                                            <Cancel color="primary" />
                                        ) : 
                                        (
                                            <NoteAdd color="primary" />
                                        )
                                    }
                                </span>
                            </Tooltip>
                            
                        </div>
                    </div> */}                        
                </div>
                
                {
                    this.state.isEditingNote ? 
                    (
                        <div className="conversation-search">
                            <div className="row">
                                <div className="col-9">
                                    <TextField
                                        onChange={this.handleNote}
                                        multiline
                                        label="Catatan"
                                        type="text"
                                        value={lastWaCsLog !== undefined && lastWaCsLog !== null && csNote !== undefined ? this.state.note : ""}
                                        className="form-control"
                                        id={"note"+fromNumber}
                                        variant="outlined"
                                        // onKeyDown={this.onKeyDownHandler}
                                        onBlur={() => {
                                            
                                        }}

                                    />
                                </div>
                                <div className="col-3">

                                    {
                                        this.state.isSavingNote ? 
                                        (
                                            <CircularProgress size={36} />
                                        ) : 
                                        (
                                            <Tooltip title="Simpan note">
                                                <div className="btn btn-warning btn-block" onClick={() => {this.handleSaveNote(this.props.data, this.state.note)}}>
                                                    <Save />
                                                </div>
                                            </Tooltip>
                                        )
                                    }

                                    
                                </div>
                            </div>
                            <br />
                            
                        </div>
                    ) : 
                    
                    lastWaCsLog !== undefined && lastWaCsLog !== null && csNote !== undefined ? 
                    (
                        <Tooltip title="Catatan CS">
                            <Chip
                                icon={<Note />}
                                label={csNote}
                                variant="outlined"
                            />
                        </Tooltip>
                    ):
                    (
                        <></>
                    )
                    
                }

            </div>
            
        </Paper>
        {/* <Divider /> */}
      </>

        
      
    );
  }

  getListItemClasses() {
    let classes = "conversation-list-item border border-danger";
    classes += this.props.data.selected === true ? "selected" : "";
    return classes;
  }

  getUreadCounterClasses(unreadCounter){
      return unreadCounter > 0 ? "label label-danger text-danger" : "label label-danger text-danger d-none";
  }
}

export default CsContactListItem;
